module.exports = __webpack_public_path__ + "img/v9.a7bacc65.png";